import React, { useEffect, useContext, useState } from 'react';
import { Container, Row, Col, Modal, ModalBody } from 'reactstrap';
import { Translate, withLocalize } from 'react-localize-redux';
import { Link } from 'react-router-dom';
import { Store } from '../Store';
import Helmet from '../components/Helmet';
import Header from '../components/Header';
import Button from '../components/Button';

import getLanguage from '../services/helpers';
import getPath from '../assets/routes/paths';

import * as api from '../services/api';
import InstaPosts from '../components/InstaPosts';
import NewsletterSignUp from '../components/NewsletterSignUp';
import Greens from '../components/Greens';

// import logotypeGolfamoreBlack from '../assets/img/logo-golfamore-black-animated.gif';

function Index({ translate }) {
  document.documentElement.classList.remove('nav-open');

  useEffect(() => {
    document.body.classList.add('index');
    window.scrollTo(0, 0);
    return function cleanup() {
      document.body.classList.remove('index');
    };
  }, []);

  const { state } = useContext(Store);
  const language = getLanguage();

  const [randCourses, setRandCourses] = useState([]);
  const [instaPosts, setInstaPosts] = useState(null);
  // const [shoGolfamoreInfo, setGhoGolfamoreInfo] = useState(true);

  useEffect(() => {
    if (state.courses.data.length) {
      const topCourses = state.courses.data.filter((c) => c.top && c.image?.default);

      if (topCourses.length) {
        const courses = [];
        for (let i = 0; i < 3; i++) {
          courses.push(topCourses[Math.floor(Math.random() * topCourses.length)]);
        }

        setRandCourses(courses);
      }
    }
  }, [state.courses.data]);

  useEffect(() => {
    (async () => {
      const { response: insta, error: instaError } = await api.getInstaFeed();
      if (!instaError) {
        setInstaPosts(insta?.slice(0, 8));
      }
    })();
  }, []);

  return (
    <>
      <Helmet title="index.sub-title" />
      <Header
        bgImage="/react-assets/img/campaign-webshop.png"
        headerSize="small"
        title={translate('default.golfhaftet')}
        subtitle={translate('index.sub-title')}
        biggerTitle
        infoFrame={{
          title1: translate('index.header-p1-title'),
          text1: translate('index.header-p1-text'),
          title2: translate('index.header-p2-title'),
          text2: translate('index.header-p2-text'),
          title3: translate('index.header-p3-title'),
          text3: translate('index.header-p3-text'),
          bottomText: translate('index.header-read-more')
        }}
      />
      {language === 'de' && (
        <Container className="mt-5">
          <video width="100%" height="640" controls>
            <source src="/react-assets/video/german-info.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </Container>
      )}
      <Container>
        <Row>
          <Col className="mb-4">
            <h2>
              <Translate id="index.some-courses" />
            </h2>
          </Col>
        </Row>
        <Row>
          {randCourses?.map((c) => (
            <Col md="4" className="mt-xs-1" key={c.id}>
              <Link to={`${getPath(language, 'GolfCourses')}${c.path}`}>
                <div style={{ position: 'relative', color: '#fff' }}>
                  <picture style={{ width: '100%', height: '350px', borderRadius: '10px' }}>
                    <source type="image/webp" srcSet={c.image.path + c.image.webp} />
                    <source type="image/png" srcSet={c.image.path + c.image.small} />
                    <img
                      src={c.image.path + c.image.small}
                      loading="lazy"
                      alt={c.golfclub}
                      style={{ width: '100%', height: '350px', borderRadius: '10px' }}
                    />
                  </picture>

                  {/* <img
                    src={c.image.path + c.image.small}
                    loading="lazy"
                    alt={c.golfclub}
                    style={{ width: '100%', height: '350px', borderRadius: '10px' }}
                  /> */}
                  <div
                    style={{
                      position: 'absolute',
                      bottom: '20px',
                      left: '16px',
                      maxWidth: '200px'
                    }}
                  >
                    <h5 className="bold mb-0">{c.golfclub}</h5>
                    <p>
                      {c.country}
                      <i className="fa fa-star ml-1 mr-1" />
                      {c.q4}
                    </p>
                  </div>
                </div>
              </Link>
            </Col>
          ))}
        </Row>
        <Row>
          <Col className="d-flex justify-content-end mt-3">
            <Button text={translate('default.show-courses')} link="GolfCourses" />
          </Col>
        </Row>
        <Greens green={1} paddingTop={80}>
          <Row>
            <Col sm="12" md="4">
              <h2 style={{ fontSize: '3.5em', lineHeight: '0.6em', textAlign: 'center' }}>
                1 400
                <br />
                <span className="text-uppercase text-1rem">
                  <Translate id="default.courses" />
                </span>
              </h2>
            </Col>
            <Col sm="12" md="4">
              {/* <i className="fa fa-user text-white" style={{ fontSize: '2rem' }} /> */}
              <h2 style={{ fontSize: '3.5em', lineHeight: '0.6em', textAlign: 'center' }}>
                178 500
                <br />
                <span className="text-uppercase text-1rem">
                  <Translate id="default.users-in-country" />
                </span>
              </h2>
            </Col>
            <Col sm="12" md="4">
              <h2 style={{ fontSize: '3.5em', lineHeight: '0.6em', textAlign: 'center' }}>
                3 450 410
                <br />
                <span className="text-uppercase text-1rem">
                  <Translate id="default.rounds" />
                </span>
              </h2>
            </Col>
          </Row>
          <Row>
            <Col className="d-flex justify-content-center pt-5">
              <Button text={translate('default.buy-golfhaftet')} link="Webshop" />
            </Col>
          </Row>
        </Greens>
        <InstaPosts posts={instaPosts} />
      </Container>
      {['sv'].includes(language) && (
        <div className="section section-gray mb-4">
          <Container>
            <Row>
              <Col className="text-align-center">
                <h2>
                  <Translate id="index.trophy-title" />
                </h2>
                <h5 className="pt-3 pb-3">
                  <Translate id="index.trophy-text" />
                </h5>
                <Button text={translate('default.read-more')} link="Events" />
              </Col>
            </Row>
          </Container>
        </div>
      )}
      <Container>
        <Greens green={2} paddingTop={40}>
          <Row>
            <Col xs="12" sm="6">
              <h3>
                <Translate id="index.wii-header" />
              </h3>
              <div style={{ color: '#000' }}>
                <Translate id="index.wii-greenfee" />
                <br />
                <strong>
                  <Translate id="index.wii-greenfee-amt" />
                </strong>
                <br />
                <Translate id="index.wii-offer" />
                <br />
                <strong>
                  <Translate id="index.wii-offer-amt" />
                </strong>
                <br />
                <Translate id="index.wii-fee" />
                <br />
                <strong>
                  <Translate id="index.wii-fee-amt" />
                </strong>
                <br />
                <Translate id="index.wii-saving" />
                <br />
                <strong>
                  <Translate id="index.wii-saving-amt" />
                </strong>
              </div>
            </Col>
            <Col xs="12" sm="5">
              <h3>
                <Translate id="index.wii-sub-header" />
              </h3>
              <p style={{ color: '#000' }}>
                <Translate id="index.wii-text" />
              </p>

              <Button text={translate('default.buy-golfhaftet')} link="Webshop" />
            </Col>
          </Row>
        </Greens>

        <NewsletterSignUp />
      </Container>
      {/* {!['de', 'en'].includes(language) && (
        <Modal isOpen={shoGolfamoreInfo} center>
          <ModalBody>
            <div className="mt-3 mb-4 text-center">
              <img src={logotypeGolfamoreBlack} alt="logtype" className="responsive" style={{ width: '250px' }} />
            </div>
            <Translate id="index.golfamore" />
            <div className="mt-3 text-center">
              <Button text={translate('default.close')} onClick={() => setGhoGolfamoreInfo(false)} />
            </div>
          </ModalBody>
        </Modal>
      )} */}
    </>
  );
}

export default withLocalize(Index);
